const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"]
const UTM_STORAGE_KEY = "utmParameters"

export const readUtmParameters = (search = "") => {
  const params = new URLSearchParams(search)
  return Object.fromEntries(
    UTM_KEYS.map(key => [key, params.get(key)]).filter(([, value]) => value)
  )
}

export const rememberUtmParameters = (search = "") => {
  const utmParameters = readUtmParameters(search)
  if (!Object.keys(utmParameters).length) return
  try {
    globalThis.sessionStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(utmParameters))
  } catch (error) {
    console.error("UTM parameters could not be stored:", error?.message)
  }
}

export const getUtmParameters = (search = "") => {
  const utmParameters = readUtmParameters(search)
  if (Object.keys(utmParameters).length) return utmParameters
  try {
    const stored = JSON.parse(globalThis.sessionStorage.getItem(UTM_STORAGE_KEY))
    return readUtmParameters(new URLSearchParams(stored || {}).toString())
  } catch (error) {
    console.error("Stored UTM parameters could not be read:", error?.message)
    return {}
  }
}
